<template>
  <div v-if="getBet.odds.length > 0">
    <div class="warning-odds-changed" v-if="warningOddsChanged">
      <span>{{ $t('updateOddsCart') }}</span>
    </div>
    <div v-if="showAlertLogin">
      <v-alert id="alertLogin" style="" dense text type="error">
        {{ $t('alertlogin') }}
      </v-alert>
    </div>
    <div v-if="showAlertNotPlayable">
      <v-alert id="showAlertNotPlayable" dense text type="error">
        {{ $t('alertNotPlayable') }}
      </v-alert>
    </div>

    <div
      v-if="getAuthenticated && getCanPlay"
      :class="[
        'btn-confirm',
        (!getBet.check && getBet.errors.length > 0) ||
        checkToAcceptNewOdds() ||
        placing ||
        getIsCartUpdating === true
          ? 'disabled'
          : '',
      ]"
      @click="saveBet"
    >
      <v-icon
        x-small
        v-if="
          (!getBet.check && getBet.errors.length > 0) || checkToAcceptNewOdds()
        "
      >
        mdi-block-helper
      </v-icon>
      {{ $t('placeBet') }}
    </div>
    <div v-else class="btn-login-cart" @click="alertLogin()">
      {{ $t('placeBet') }}
    </div>

    <div class="actions">
      <div class="btn-clear" @click="clearCart()">
        {{ $t('removeBet') }}
      </div>
      <div
        :class="[
          'btn-book',
          (!getBet.check && getBet.errors.length > 0) ||
          checkToAcceptNewOdds() ||
          (getBet.context != 'prematch' && getBet.context != 'antepost')
            ? 'disabled'
            : '',
        ]"
        @click="bookingBet()"
      >
        {{ $t('bookBet') }}
      </div>
    </div>

    <v-dialog
      v-if="!getModalIdle"
      transition="dialog-top-transition"
      max-width="700"
      v-model="dialog"
      content-class="modal-on-top"
      persistent
    >
      <v-card class="text-center">
        <div class="close-modal">
          <v-icon @click="closeModalDialogConfirm()">mdi-close</v-icon>
        </div>
        <div class="pt-5 pb-5">
          <v-col cols="12">
            <v-icon x-large>mdi-checkbox-marked-circle</v-icon>
          </v-col>
          <v-col
            cols="12"
            class="message-bet-success"
            v-if="this.bookedCode == ''"
          >
            <span class="ml-2 text-uppercase">{{ $t('betAccepted') }}</span>
            <br />
            <span class="ml-2 text-uppercase" v-if="this.placedBet != ''">
              {{ this.placedBet }}
            </span>
          </v-col>

          <v-col cols="12" class="message-bet-success" v-else>
            <span class="ml-2 text-uppercase">{{ $t('betBooked') }}</span>
            <br />
            <span
              class="ml-2 text-uppercase"
              style="font-size: 40px"
              v-if="this.bookedCode != ''"
            >
              {{ this.bookedCode }}
            </span>
            <br />
            <span class="text-success" v-if="showCopy">{{
              $t('codeBetCopy')
            }}</span>
          </v-col>

          <v-col cols="12" class="msg-success-bet-button">
            <v-btn
              elevation="2"
              class="mr-2"
              @click="print"
              v-if="this.bookedCode == ''"
            >
              <v-icon dark class="mr-2"> mdi-printer </v-icon>
              {{ $t('print') }}
            </v-btn>
            <v-btn
              elevation="2"
              class="mr-2"
              color="success"
              @click="clearCart"
            >
              <v-icon dark class="mr-2"> mdi-file-outline </v-icon>
              {{ $t('newBet') }}
            </v-btn>
            <v-btn
              elevation="2"
              class="mr-2"
              color="primary"
              @click="reloadBet"
            >
              <v-icon dark class="mr-2"> mdi-reload </v-icon>
              {{ $t('reloadBet') }}
            </v-btn>
          </v-col>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!getModalIdle"
      transition="dialog-top-transition"
      max-width="700"
      v-model="dialogError"
      content-class="modal-on-top"
    >
      <v-card class="text-center pt-15 pb-15">
        <v-col cols="12">
          <v-icon
            x-large
            @click="
              dialogError = false
              placedBet = ''
              bookedCode = ''
            "
            >mdi-close-circle
          </v-icon>
        </v-col>
        <v-col cols="12" class="message-bet-success">
          <span class="ml-2 text-uppercase">{{ $t(error_code) }}</span
          ><br />
          <span style="font-size: 12px">{{
            this.formatMessage(error_reason)
          }}</span>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Actions',
  data: () => ({
    dialog: false,
    dialogError: false,
    error_code: '',
    error_reason: 'n.d.',
    bookedCode: '',
    placedBet: '',
    showCopy: false,
    placing: false,
    showAlertLogin: false,
    showAlertNotPlayable: false,
    warningOddsChanged: false,
    print_electron: false,
    icarus: window.icarus,
  }),
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getAuthenticated: 'user/getAuthenticated',
      getCanPlay: 'user/getCanPlay',
      getLanguage: 'settings/getLanguage',
      getPlatformSettings: 'settings/getPlatformSettings',
      getOddsVariation: 'cart/getOddsVariation',
      getSettings: 'cart/getSettings',
      getType: 'user/getType',
      getCashier: 'user/getCashier',
      getElectron: 'settings/getElectron',
      getModalIdle: 'user/getModalIdle',
      getOddsType: 'odds/getOddsType',
      getShortCode: 'settings/getShortCode',
      getId: 'user/getId',
      getEnableClearCartAtPlaceBet: 'settings/getEnableClearCartAtPlaceBet',
      getIsCartUpdating: 'cart/getIsCartUpdating',
    }),
  },
  methods: {
    ...mapActions({
      resetCart: 'cart/resetCart',
      removeOddFromCart: 'cart/removeOddFromCart',
      refreshCart: 'cart/refreshCart',
      placeBet: 'cart/placeBet',
      bookBet: 'cart/bookBet',
      replaceOdds: 'cart/replaceOdds',
      acceptAllOdds: 'cart/acceptAllOdds',
      acceptOdd: 'cart/acceptOdd',
      setLoadingCart: 'cart/setLoadingCart',
      addBetInAcceptance: 'cart/addBetInAcceptance',
    }),

    formatMessage(msg) {
      return unescape(msg)
    },
    async saveBet() {
      const vue = this
      vue.placedBet = ''
      vue.bookedCode = ''

      if (vue.placing || vue.getIsCartUpdating === true) {
        return
      }
      await vue.setLoadingCart({ status: true })
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      if (
        (!vue.getBet.check && vue.getBet.errors.length > 0) ||
        vue.checkToAcceptNewOdds() ||
        vue.placing
      ) {
        await vue.setLoadingCart({ status: false })
        vue.placing = false
        return
      } else {
        vue.placing = true
        const response = await this.placeBet({
          betContext: vue.getBet.context,
          lang: vue.getLanguage,
          accept_odds: vue.getOddsVariation,
        })

        if (response.result == true) {
          vue.placedBet = response.bet_code
          if (
            vue.getElectron &&
            vue.getSettings.enableDirectPrintAgency &&
            (vue.getType == 4 || (vue.getType == 2 && vue.getCashier))
          ) {
            this.print_electron = true
            this.print()
            this.clearCart()
            vue.warningOddsChanged = false
            vue.dialogError = false
            vue.placing = false
            await vue.setLoadingCart({ status: false })
          } else {
            vue.warningOddsChanged = false
            vue.dialog = true
            vue.dialogError = false
            vue.placing = false
            await vue.setLoadingCart({ status: false })
          }
        } else {
          vue.placing = false
          await vue.setLoadingCart({ status: false })
          switch (response.error_code) {
            case 'update_odds':
              if (vue.getOddsVariation) {
                vue.warningOddsChanged = true
                await vue.replaceOdds({ odds: response.data_to_update })
                await vue.acceptAllOdds()
                await this.$root.$emit('forceUpdateOddsSummary')
                await vue.refreshCart()
                const check_disabled = _.find(response.data_to_update, {
                  reason: 'disabled',
                })
                const check_time_over = _.find(response.data_to_update, {
                  reason: 'time_over',
                })
                if (!check_time_over && !check_disabled) {
                  await this.saveBet()
                }
              } else {
                await vue.replaceOdds({ odds: response.data_to_update })
                await this.$root.$emit('forceUpdateOddsSummary')
              }
              break
            case 'totals_incorrect':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_check':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_repetition':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('vincols_repetitions')
              break
            case 'external_save_failed':
              vue.dialogError = true
              if (response.reason === 'Errore range di quote non rispettate') {
                vue.error_code = vue.$t('limitExceed')
              } else {
                vue.error_code = vue.$t('bet_not_accepted')
              }
              vue.error_reason = response.reason || vue.$t('pleaseTryAgain')
              break
            case 'review':
              vue.dialogError = true
              vue.error_code = vue.$t('betReview')
              vue.error_reason = vue.$t('betUnderReview')
              vue.addBetInAcceptance({ code: response.result })
              break
            case 'event_not_avaiable':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('oddNotAvailableInCart')
              break
            case 'user_locked':
              vue.dialogError = true
              vue.error_code = vue.$t('user_locked')
              vue.error_reason = vue.$t('errors.user_locked_text')
              break
            case 'agency_locked':
              vue.dialogError = true
              vue.error_code = vue.$t('agency_locked')
              vue.error_reason = vue.$t('agency_locked')
              break
            case 'MAX_CURRENT_WEEK_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_WEEK_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_DAY_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_DAY_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'user_profile_forbidden':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.userProfileNotEnabled')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'INVALID_CURRENCY':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'reject_bet_time_live_odd_expired':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('marketClosedPleaseTryAgain')
              break
            case 'user_staged':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('errors.user_staged_text')
              break
            default:
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
          }
        }
      }
    },

    async bookingBet() {
      const vue = this
      if (
        (vue.getBet.context !== 'prematch' &&
          vue.getBet.context !== 'antepost') ||
        vue.getIsCartUpdating === true
      ) {
        return
      }
      vue.showCopy = false
      await vue.setLoadingCart({ status: true })
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      if (
        (!vue.getBet.check && vue.getBet.errors.length > 0) ||
        vue.checkToAcceptNewOdds()
      ) {
        await vue.setLoadingCart({ status: false })
        return
      } else {
        const response = await this.bookBet({
          betContext: vue.getBet.context,
          lang: vue.getLanguage,
        })
        if (response.result == true) {
          vue.bookedCode = response.bet_code
          vue.dialog = true
          vue.dialogError = false
          await vue.setLoadingCart({ status: false })
        } else {
          await vue.setLoadingCart({ status: false })
          switch (response.error_code) {
            case 'update_odds':
              if (vue.getOddsVariation) {
                await vue.replaceOdds({ odds: response.data_to_update })
                await vue.acceptAllOdds()
                await this.$root.$emit('forceUpdateOddsSummary')
                await vue.refreshCart()
                await this.bookingBet()
              } else {
                await vue.replaceOdds({ odds: response.data_to_update })
                await this.$root.$emit('forceUpdateOddsSummary')
              }
              break
            case 'totals_incorrect':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'vincols_check':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'external_save_failed':
              vue.dialogError = true
              if (response.reason === 'Errore range di quote non rispettate') {
                vue.error_code = vue.$t('limitExceed')
              } else {
                vue.error_code = vue.$t('bet_not_accepted')
              }
              vue.error_reason = response.reason || vue.$t('pleaseTryAgain')
              break
            case 'cant_book_live_odds':
              vue.dialogError = true
              vue.error_code = vue.$t('cant_book_live_odds')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_WEEK_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_WEEK_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'MAX_CURRENT_DAY_PLAYABLE':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.MAX_CURRENT_DAY_PLAYABLE')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'INVALID_CURRENCY':
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
            case 'reject_bet_time_live_odd_expired':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('marketClosedPleaseTryAgain')
              break
            case 'user_staged':
              vue.dialogError = true
              vue.error_code = vue.$t('bet_not_accepted')
              vue.error_reason = vue.$t('errors.user_staged_text')
              break
            default:
              vue.dialogError = true
              vue.error_code = vue.$t('errors.systemError')
              vue.error_reason = vue.$t('pleaseTryAgain')
              break
          }
        }
      }
    },

    async clearCart() {
      this.showCopy = false
      this.dialog = false
      this.dialogError = false
      this.warningOddsChanged = false
      this.showAlertLogin = false
      this.showAlertNotPlayable = false
      this.$root.$emit('cart_handling', true)
      await this.resetCart()
    },
    async alertLogin() {
      if (!this.getAuthenticated) {
        this.showAlertLogin = true
      }
      if (!this.getCanPlay) {
        this.showAlertNotPlayable = true
      }
    },
    print() {
      if (this.icarus) {
        IcarusInterface.printTicketRocky(this.placedBet.toString())
        this.dialog = false
      } else {
        if (this.print_electron) {
          window.open(
            this.getPlatformSettings.print_endpoint +
              this.placedBet +
              '&electron=1',
            '_blank',
            'height=600,width=350'
          )
        } else {
          window.open(
            this.getPlatformSettings.print_endpoint +
              this.placedBet +
              '&type_odd=' +
              this.getOddsType,
            '_blank',
            'height=600,width=350'
          )
        }
        this.dialog = false
      }
      this.showCopy = false
      this.dialogError = false
    },

    reloadBet() {
      this.showCopy = false
      this.dialog = false
      this.dialogError = false
    },

    checkToAcceptNewOdds() {
      const vue = this
      const changed = _.filter(vue.getBet.odds, function (odd) {
        return odd.changed
      })
      return changed.length > 0
    },

    handleCopyStatus(status) {
      this.copySucceeded = status
    },

    printBet(bet) {
      const codeBet = this.getShortCode == true ? bet.betCode : bet.code
      if (this.getShortCode) {
        window.open(
          this.getPlatformSettings.print_endpoint +
            codeBet +
            '&login=' +
            this.getType +
            '&ancestors=' +
            this.getId +
            '&type_odd=' +
            this.getOddsType,
          '_blank',
          'height=600,width=350'
        )
      } else {
        window.open(
          this.getPlatformSettings.print_endpoint +
            codeBet +
            '&type_odd=' +
            this.getOddsType,
          '_blank',
          'height=600,width=350'
        )
      }
      this.dialog = false
    },

    async closeModalDialogConfirm() {
      const vm = this
      this.dialog = false
      this.placedBet = ''
      this.bookedCode = ''
      if (vm.getEnableClearCartAtPlaceBet === true) {
        vm.$root.$emit('cart_handling', true)
        await vm.resetCart()
      }
    },
  },
  mounted() {
    const vm = this

    this.$root.$on('print_this_bet', function (bet) {
      vm.printBet(bet)
    })
  },
  beforeDestroy() {
    this.$root.$off('print_this_bet', () => {})
  },
}
</script>
